module.exports = __webpack_public_path__ + "static/img/qrcode_h5_2.369a0c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/chataxera/qrcode_h5_2.png
// module id = mFAS
// module chunks = 34